module.exports = __webpack_public_path__ + "img/book_02.070cb4bd.jpg";